export const siteColors = {
    white: '#fff',
    grey: '#ECE8E8',
    black: '#251f10',
    lightOlive: '#bab86c',
    darkOlive: '#556b2f',
};

